import { default as appInfo } from '../package.json';

export const APP_NAME = appInfo.name;

export const AUDIO_LEVEL_THRESHOLD = 200;

export const AUDIO_LEVEL_STANDARD_DEVIATION_THRESHOLD = AUDIO_LEVEL_THRESHOLD * 0.05; // 5% threshold

export const INPUT_TEST_DURATION = 20000;

export const RECORD_DURATION = 4000;

// Extended connectivity test durations (in milliseconds)
export const BITRATE_TEST_DURATION = 600000; // 10 minutes (600 seconds) for comprehensive bitrate analysis
export const EXTENDED_BITRATE_TEST_DURATION = 1200000; // 20 minutes for ultra-deep quality metrics
export const QUALITY_MONITORING_INTERVAL = 1000; // Sample quality metrics every second

// Call simulation duration options (in milliseconds)
export const CALL_SIMULATION_DURATIONS = {
  '15 seconds': 15000,
  '1 minute': 60000,
  '5 minutes': 300000,
  '10 minutes': 600000,
  '15 minutes': 900000,
  '30 minutes': 1800000,
} as const;

export type CallSimulationDurationKey = keyof typeof CALL_SIMULATION_DURATIONS;
export type CallSimulationDurationValue = typeof CALL_SIMULATION_DURATIONS[CallSimulationDurationKey];
